import { Component } from '@angular/core';

@Component({
    selector: 'app-create-customer',
    templateUrl: './create-customer.component.html',
    styleUrls: ['./create-customer.component.scss']
})
/** create-customer component*/
export class CreateCustomerComponent {
    /** create-customer ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/customer-components/create-customer/create-customer.component.ts